import { Divider, Space } from 'antd';
import dayjs from 'dayjs';
import { history } from 'ice';
import React from 'react';

import type Message from '@/types/database/message';

import styles from './index.module.scss';
import type { UpdateMethods } from './types';

interface NoticeProps {
  data: Message;
  isLastOne: boolean;
  noticeType: 'personal' | 'system' | 'baEvent';
  updateMethods: UpdateMethods;
}

const Notice = ({
  data,
  isLastOne,
  noticeType,
  updateMethods,
}: NoticeProps) => {
  const { title, content, createdTime, redirect } = data;
  const { updateIsShowPersonalNoticeDetail, updatePersonalNoticeDetail } =
    updateMethods;

  const handleRedirect = () => {
    const bRedirect = redirect.replace('/ezpro', '/mobile');
    history.push(`${bRedirect}`);
  };

  const showPersonalNoticeDetail = () => {
    updateIsShowPersonalNoticeDetail(true);
    updatePersonalNoticeDetail(data as Message);
  };

  return (
    <>
      <Space className={styles.noticeTitleContainer}>
        <p>{title}</p>
        <p>{dayjs(createdTime).format('YYYY-MM-DD')}</p>
      </Space>
      <a
        className={isLastOne ? styles.lastNotice : styles.noticeContent}
        onClick={
          noticeType !== 'personal' ? handleRedirect : showPersonalNoticeDetail
        }
      >
        {content}
      </a>
      {!isLastOne && <Divider />}
    </>
  );
};

export default Notice;
